import React from "react";

import Button from "../Button";
import Icon from "../Icon";

import * as cardsStyles from "./Cards.module.css";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const Card = ({ props }) => {
  const {
    icon,
    headline,
    copy,
    cta,
    backgroundColor,

    to,
    opensInNewWindow,
  } = props;

  /* ${cardsStyles[backgroundColor]} */

  if (to) {
    return (
      <Link
        className={`${cardsStyles.card} ${cardsStyles[backgroundColor]}`}
        to={to}
        target={opensInNewWindow ? "_blank" : null}
        rel={opensInNewWindow ? "noreferrer" : null}
        title={headline || ""}
      >
        <div>
          {icon && <Icon props={icon} />}
          <h5>{headline}</h5>
          <p>{copy}</p>
        </div>
        {cta && (
          <div className={cardsStyles.ctaButton}>
            <Button
              // isLink={!cta.styleAsButton}
              destination={cta.to}
              opensInNewWindow={cta.opensInNewWindow}
              styleAsButton={cta.styleAsButton}
            >
              {cta.title}
            </Button>
          </div>
        )}
      </Link>
    );
  } else {
    return (
      <div className={`${cardsStyles.card} ${cardsStyles[backgroundColor]}`}>
        {icon && <Icon props={icon} />}
        <h5>{headline}</h5>
        <p>{copy}</p>
        {cta && (
          <div>
            <Button
              // isLink={!cta.styleAsButton}
              destination={cta.to}
              opensInNewWindow={cta.opensInNewWindow}
              styleAsButton={cta.styleAsButton}
            >
              {cta.title}
            </Button>
          </div>
        )}
      </div>
    );
  }
};

const TallCard = ({ props }) => {
  const {
    icon,
    headline,
    copy,
    cta,
    backgroundColor,
    backgroundImage,
    to,
    opensInNewWindow,
  } = props;

  if (to) {
    return (
      <Link
        className={`${cardsStyles.card} ${cardsStyles[backgroundColor]}`}
        to={to}
        target={opensInNewWindow ? "_blank" : null}
        rel={opensInNewWindow ? "noreferrer" : null}
        title={headline || ""}
      >
        {backgroundImage && (
          <GatsbyImage
            image={backgroundImage.gatsbyImageData}
            alt={backgroundImage.desctription}
            className={cardsStyles.backgroundImage}
          />
        )}
        {backgroundImage && backgroundColor && (
          <div
            className={`${cardsStyles.overlay} ${cardsStyles[backgroundColor]}`}
          />
        )}
        <div className={cardsStyles.tallHeadline}>
          <h6>{headline}</h6>
          <Icon
            props={{
              name: "fa-arrow-right",
              isBrand: false,
              type: "button",
              size: "2x",
              color: "white",
            }}
          />
        </div>
      </Link>
    );
  } else {
    return (
      <div className={`${cardsStyles.card} ${cardsStyles[backgroundColor]}`}>
        {icon && <Icon props={icon} />}
        <h6>{headline}</h6>
        <p>{copy}</p>
        {cta && (
          <div>
            <Button
              // isLink={!cta.styleAsButton}
              destination={cta.to}
              opensInNewWindow={cta.opensInNewWindow}
              styleAsButton={cta.styleAsButton}
            >
              {cta.title}
            </Button>
          </div>
        )}
      </div>
    );
  }
};

const Cards = ({ props }) => {
  const { headline, cards, variant } = props;
  const numOfCards = `containerHas${cards.length}`;

  return (
    <div
      className={`${cardsStyles.cards} ${
        variant ? cardsStyles[variant] : cardsStyles.default
      }`}
    >
      {headline && <h1 className={cardsStyles.headline}>{headline}</h1>}
      <div
        className={`${cardsStyles.cardContainer} ${cardsStyles[numOfCards]}`}
        // data-aos="zoom-in-up"
      >
        {cards.map((card, index) => {
          if (variant === "tall") {
            return <TallCard key={index} props={card} />;
          } else {
            return <Card key={index} props={card} />;
          }
        })}
      </div>
    </div>
  );
};

export default Cards;
